export const ActionType = {
  SET_USER: "set_user",
  SET_FCM_TOKEN: "set_fcm_token",
  SET_LOADING: "set_loading",
  SET_CART: "set_cart",
  SET_WISHLIST: "set_wishlist",
  SET_MAIN_CLIENT: "set_main_client",

  SET_PRODUCTS: "set_products",
  SET_CATEGORIES: "set_categories",

  SET_GROUPS: "set_groups",
  SET_OVERVIEW: "set_overview",

  SET_SELECTED_CATEGORIES: "set_selected_categories",
  SET_SELECTED_CART_INFO: "set_selected_cart_info",
  SET_DIVISIONS: "set_divisions",
  SET_LOCAL_DIVISION: "SET_LOCAL_DIVISION",
};
